import type { AppSettings } from '../types';

const KEY = 'rollpick:settings';

const DEFAULTS: AppSettings = {
  theme: 'system',
  soundEnabled: true,
  selectedMapId: 'classic',
  language: 'ko',
  lastClassId: null,
  shuffleParticipants: true,
  itemsEnabled: false,
  useRandomFinalObstacles: true,
};

export function getSettings(): AppSettings {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveSettings(settings: Partial<AppSettings>): AppSettings {
  const current = getSettings();
  const next = { ...current, ...settings };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}
